App.namespace.wrap('components.home_search', ({ getValidationErrorName, disableLocationPageEvents } = { disableLocationPageEvents: false }) => {
  const searchButton = $.fn.findAnyInDocument('.js-hero-search');
  const $locationSelect = $.fn.findAnyInDocument('#hero-location');
  const $roomTagInput = $.fn.findOneInDocument('#hero-room-tag');

  const $peopleInput = $('#hero-people');
  const $eventTypeInput = $('#hero-event-type');

  const buildSearchUrl = (roomTag, subdir, params) => {
    if (!subdir) {
      subdir = window.__TGV_ISO_COUNTRY_SUBDIR;
    }

    if (!subdir) {
      Rollbar.error(`Missing subdir variable, got: ${subdir}`);
    }

    const base = App.es6.shared.fill_variables(window.__TGV_ROUTE_SEARCH, {
      roomTag,
      subdir,
    });

    const url = new URL(base);

    Object.entries(params).forEach(([key, value]) => {
      if (key === 'people' && value === '') {
        return; // do not append empty people
      }
      if (key === 'neighbourhood' && value === window.__TGV_SEARCH_FORM_DATA?.label) {
        return; // do not append empty default location label
      }
      url.searchParams.set(key, value);
    });

    return url.href;
  };

  const searchEvent = (locationLabel, city, roomTag, people, validationError = null) => {
    if (disableLocationPageEvents) {
      App.track.event('clicked_to_search_page', {
        section: 'venue_page_search_bar',
        element: 'search_button',
        element_value: roomTag || 'error',
        interaction: 'click',
      });
    } else {
      App.track.event('location_page_search_button_clicked', {
        location_name: locationLabel,
        event_tag_slug: roomTag,
        country: window.__TGV_ISO_COUNTRY_CODE,
        city,
        number_of_people: people !== "" ? people : null,

        section: "header",
        interaction: "click",
        element: "search",
        element_value: $eventTypeInput.val(),
        validation_error: validationError,
      });
    }
  }

  let GOOGLE_AUTOCOMPLETE_COUNTER = 0;

  const search = (e, wasManuallyTriggeredParam) => {
    if (window.googleAutoCompleteLocationBoundsIsLoading && GOOGLE_AUTOCOMPLETE_COUNTER < 10) {
      GOOGLE_AUTOCOMPLETE_COUNTER++;
      setTimeout(() => search(e, wasManuallyTriggeredParam), 100);
      return;
    }

    if (!disableLocationPageEvents && wasManuallyTriggeredParam !== 'triggered') {
      sendLocationPageInteractionEvent('search_button', $roomTagInput.val(), 'click');
    }

    let roomTag = $roomTagInput.val();
    const people = $peopleInput.val();

    const searchedText = $eventTypeInput.devbridgeAutocomplete()?.currentValue?.trim()?.toLowerCase();
    if (!roomTag && (window.googleAutoCompleteForceRoomTag || (!window.__TGV_ROOM_TAG && !searchedText))) {
      roomTag = 'event-venue';
    }

    let locationData = window.__TGV_SEARCH_FORM_DATA;
    let city = window.__TGV_GA4_TRACKING.city;
    if ($locationSelect && $locationSelect.data('getSelection') && $locationSelect.data('getSelection')()) {
      const selectionData = $locationSelect.data('getSelection')();
      locationData = {
        label: selectionData.value,
        ...selectionData.data,
      };
      city = locationData.label;
    }

    const validationErrorName = getValidationErrorName();
    if (validationErrorName) {
      searchEvent(locationData?.label, city, roomTag, people, validationErrorName);
      return;
    }

    if (!locationData) {
      Rollbar.error('Missing locationData, got', locationData);
    }

    const params = {
      people,
    };

    let locationGeo;
    if (window.googleAutoCompleteLocationBounds) {
      locationData = window.__TGV_SEARCH_FORM_DATA;
      locationGeo = {
        ...window.googleAutoCompleteLocationBounds
      };
      if (window.googleAutoCompleteLocationFormattedAddress !== null) {
        params.neighbourhood = window.googleAutoCompleteLocationFormattedAddress;
      } else if (locationData.label) {
        params.neighbourhood = locationData.label;
      }
    } else if (locationData.locationId) {
      locationGeo = {
        location_id: locationData.locationId,
      };
    } else {
      if (wasManuallyTriggeredParam !== 'triggered') {
        searchEvent(locationData.label, city, roomTag, people, 'location');
      }
      console.error(locationData);
      throw new Error('Invalid location Data');
    }

    if (wasManuallyTriggeredParam !== 'triggered') {
      searchEvent(locationData.label, city, roomTag, people);

      if (!disableLocationPageEvents) {
        App.track.event('clicked_to_search_page', {
          location_name: locationData.label,
          event_tag_slug: roomTag,
          city,
          number_of_people: people !== "" ? people : null,
          section: "header",
          interaction: "click",
          element: "search_button",
          element_value: roomTag,
        });
      }
    }

    if (window.location.href.includes('E2E_STOP_REDIRECTION')) {
      return;
    }

    const subdir = locationGeo.subdir || locationData.subdir;
    window.location = buildSearchUrl(roomTag, subdir, {
      ...locationGeo,
      ...params,
    });
  };

  const sendLocationPageInteractionEvent = (element, elementValue, interaction) => {
    App.track.event('location_page_interaction', { section: 'header', element, element_value: elementValue, interaction });
  }

  searchButton.on('click', search);

  if (!disableLocationPageEvents) {
    // location
    $locationSelect.on('click', () => {
      sendLocationPageInteractionEvent('location', null, 'click');
    });

    // people
    $peopleInput.on('click', () => {
      sendLocationPageInteractionEvent('people', null, 'click');
    });
    $peopleInput.on('change', () => {
      $peopleInput.val(parseInt($peopleInput.val(), 10));
      sendLocationPageInteractionEvent('people', $peopleInput.val(),'change');
    });
    $peopleInput.on('keydown', (e) => {
      if (['e', 'E', '+', '-', '.', ','].includes(e.key)) {
        e.preventDefault();
      }
    });

    // event_type
    $eventTypeInput.on('click', () => {
      sendLocationPageInteractionEvent('event_tag_slug', null, 'click');
    });
  }
});
